import { render, staticRenderFns } from "./WebDevView.vue?vue&type=template&id=0f612655&scoped=true"
import script from "./WebDevView.vue?vue&type=script&lang=js"
export * from "./WebDevView.vue?vue&type=script&lang=js"
import style0 from "./WebDevView.vue?vue&type=style&index=0&id=0f612655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f612655",
  null
  
)

export default component.exports